/* eslint-disable import/prefer-default-export */
export function processNumber({ policyNumber, documentNumber, id: quoteId }) {
  const processType =
    (policyNumber && 'policyNumber') ||
    (documentNumber && 'documentNumber') ||
    (quoteId && 'quoteId');

  switch (processType) {
    case 'policyNumber':
      return {
        processId: policyNumber,
        type: 'policy'
      };

    case 'documentNumber':
      return {
        processId: documentNumber,
        type: 'proposal'
      };

    case 'quoteId':
    default:
      return {
        processId: quoteId,
        type: 'quote'
      };
  }
}
